module.exports = __webpack_public_path__ + "img/imgHeader_04.eae24948.png";